/* GST invoice request on cart + minicart. Saves GSTIN and business name as cart attributes. */
(function () {
  if (customElements.get('infinote-gst')) return;

  var GSTIN = /^(0[1-9]|[1-2][0-9]|3[0-8])[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
  var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  function validGstin(v) {
    if (!GSTIN.test(v)) return false;
    var sum = 0;
    for (var i = 0; i < 14; i++) {
      var p = CHARS.indexOf(v[i]) * (i % 2 === 0 ? 1 : 2);
      sum += Math.floor(p / 36) + (p % 36);
    }
    return CHARS[(36 - (sum % 36)) % 36] === v[14];
  }

  function save(attrs) {
    return fetch((window.routes && routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  class InfinoteGst extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-gst-toggle]');
      this.fields = this.querySelector('[data-gst-fields]');
      this.gstin = this.querySelector('[data-gstin]');
      this.name = this.querySelector('[data-gst-name]');
      this.error = this.querySelector('[data-gst-error]');
      this.toggle.addEventListener('change', () => this.onToggle());
      this.gstin.addEventListener('input', () => {
        this.gstin.value = this.gstin.value.toUpperCase().replace(/[^0-9A-Z]/g, '');
        this.showError(false);
      });
      this.gstin.addEventListener('change', () => this.persist());
      this.name.addEventListener('change', () => this.persist());
      var form = document.getElementById(this.dataset.form);
      if (form) {
        form.addEventListener('submit', (e) => {
          if (e.submitter && e.submitter.name !== 'checkout') return;
          if (!this.isValid()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.gstin.focus();
          }
        }, true);
      }
    }
    onToggle() {
      var on = this.toggle.checked;
      this.fields.hidden = !on;
      if (on) return this.gstin.focus();
      this.gstin.value = '';
      this.name.value = '';
      this.showError(false);
      save({ GSTIN: '', 'GST business name': '' });
    }
    isValid() {
      if (!this.toggle.checked) return true;
      var ok = validGstin(this.gstin.value);
      this.showError(!ok);
      return ok;
    }
    showError(show) {
      this.error.hidden = !show;
      this.gstin.setAttribute('aria-invalid', show ? 'true' : 'false');
    }
    persist() {
      if (!this.isValid()) return;
      save({ GSTIN: this.gstin.value, 'GST business name': this.name.value.trim() });
    }
  }
  customElements.define('infinote-gst', InfinoteGst);
})();
